/*
 * Base class for all pages. Sets specific default values.
 * isBrowser is used to make current environment available accross all pages
 * subscription is used bind a subscription of an http call to the page/component and destroy this subscription when the page is destroyed
 */

import { Component, OnDestroy } from '@angular/core';
import { BaseComponent } from '@components/base/base.component';

import { BaseService } from '../../services/base/base.service';

@Component({
  selector: 'app-base-page',
  template: ''
})
export abstract class BasePage extends BaseComponent implements OnDestroy {
  // declaration of fields
  canBeDeactivated: boolean;
  submit: boolean;

  constructor(public baseService: BaseService) {
    super(baseService);
    this.canBeDeactivated = true;
    this.submit = false;
  }
}
